module.exports = __webpack_public_path__ + "img/lb1.c1b46d78.png";